import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrustedCertificatesComponent } from './trusted-certificates.component';
import {ActionBarModule} from '../../../components/action-bar/action-bar.module';
import {MaterialModule} from '../../../material.module';
import { TrustedCertificateDialogComponent } from './trusted-certificate-dialog/trusted-certificate-dialog.component';
import {DialogModule} from '../../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';
import {ArmTableModule} from '../../../components/arm-table/arm-table.module';



@NgModule({
  declarations: [TrustedCertificatesComponent, TrustedCertificateDialogComponent],
    imports: [
        CommonModule,
        ActionBarModule,
        MaterialModule,
        DialogModule,
        FormsModule,
        InfraModule,
        ArmTableModule
    ]
})
export class TrustedCertificatesModule { }
